<template>
  <div class="w-full mx-auto sm:max-w-5xl 2xl:max-w-6xl 3xl:max-w-8xl 4xl:max-w-9xl">
    <h5 class="zt-dashboard-title" data-testid="user-favorites-items-count">Integrations</h5>
    <template v-if="hasIntegrations">
      <IntegrationsGrid />
    </template>
    <template v-else>
      <p>No integrations available. Contact your account admin to enable it.</p>
    </template>
  </div>
</template>

<script lang="ts" setup>
import IntegrationsGrid from '@/modules/integrations/components/IntegrationsGrid.vue';
import { onMounted, computed } from 'vue';
import { useIntegrationStore } from '@/modules/integrations/store/useIntegrationStore';

const integrationStore = useIntegrationStore();
const hasIntegrations = computed(() => integrationStore.integrations.length > 0);

onMounted(() => {
  integrationStore.fetchIntegrations();
});
</script>

<style scoped>
.zt-dashboard-title {
  font-size: 1.25rem;
  font-weight: 500;
  display: flex;
  flex-shrink: 1;
  align-items: center;
  gap: 0.5rem;
  margin: 0;
}
</style>
